import CallToAction from '../components/CallToAction'
import { INSTITUCIONES } from '../config/institutions'
import '../styles/landing.css'

export default function Hero() {
  return (
    <section id="hero">
      <div className="hero-container">

        {/* Titulo a todo lo ancho */}
        <h2 className="hero-title">
          Lleva tus estudios a un nivel superior con Ascensos App Vortex.
        </h2>

        {/* Fila: texto + logo */}
        <div style={{ textAlign: 'justify' }} className="hero-row">
          <p className="hero-text">
            Un sistema integral de educación en la palma de tu mano para el personal de SEMAR,
            Guardia Nacional y SEDENA. Estudia leyendo, escuchando e interactuando, y crea tus
            propios recursos para ese ascenso que tanto deseas, ya sea por promoción, adecuación
            o cambio de situación — Ascensos App está para ayudarte.
          </p>

          {/* Visual */}
          <div className="hero-visual">
            <img
              src="/icons/logo.png"
              alt="AscensosApp Vortex"
              className="hero-logo"
            />

            <a href="#instituciones" className="hero-institution-row" aria-label="Conoce el contenido por institución">
              {INSTITUCIONES.map((institucion) => (
                <span
                  key={institucion.id}
                  className="hero-institution-chip"
                  style={{ borderColor: institucion.accent }}
                >
                  <span aria-hidden="true">{institucion.emoji}</span>
                  {institucion.nombre}
                </span>
              ))}
            </a>
          </div>
        </div>

        {/* Botones */}
        <CallToAction />

      </div>
    </section>
  )
}
